import React from "react";
import { useMsal } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";
import Button01 from "@src/components/button/Button01";
import colors from "@assets/colors";
import images from "@assets/images";
import useStyles from "./styles.css";
/**
 * Renders a drop down button with child buttons for logging in with a popup or redirect
 * Note the [useMsal] package 
 */
export const  MicrosoftSignInButton = () => {
  const styles = useStyles();
  const { instance, inProgress } = useMsal();
  const loginRequest = {
    scopes: []
  };

  const handleLogin = (loginType: string) => {
    if (inProgress !== InteractionStatus.None) {
      console.log("MSAL interaction already in progress");
      return;
    }

    window.sessionStorage.clear();
  
    if (loginType === "popup") {
      instance.loginPopup({
        ...loginRequest,
        prompt:"create",
      }).catch((e) => {
        console.log(e);
      });
    } else if (loginType === "redirect") {
      instance.loginRedirect({
        ...loginRequest,
        prompt:"create",
      }).catch((e) => {
        console.log(e);
      });
    }
  };


  return (
    <Button01
      onPress={() => handleLogin("popup")}
      source={images.microsoft}
      color={colors.gray1}
      label=" "
      labelStyle={{marginRight: -45, width: 30, height: 30}}
      style={styles.btn_google}
    />
  );
};